<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div slot="header">
            <b v-html="headerTitle" />
          </div>
          <LoadingSpinner :loading="loadingItem" :text="loadingText" />
          <b-form @submit.prevent="save" v-show="!loadingItem">
            <b-form-group
              :label="$lang.profileLang.parvandeh_status"
              label-for="status_selected"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.profileLang.parvandeh_status"
                :rules="$v.status_selected.$params"
              />
              <selectFind
                :options="status_options"
                v-model="$v.status_selected.$model"
                label="text"
                id="value"
                :isValid="
                  $v.status_selected.$dirty ? !$v.status_selected.$error : null
                "
                :loading="status_selected_Loading"
              />
              <b-form-invalid-feedback
                :style="{
                  display: $v.status_selected.$error ? 'block' : 'none',
                }"
                id="status_selected_feedback"
              >
                {{
                  $lang.error_required
                    | replace($lang.profileLang.parvandeh_status)
                }}
              </b-form-invalid-feedback>
            </b-form-group>
            <TagComponent
              v-if="allowReasonId"
              :label="$lang.profileLang.parvandeh_end_reason"
              category_name="parvandeh_end_reason"
              :multiple="false"
              :requiredLabel="statusEndReasonRequired"
              :parentPermissions="parentPermissions"
              :checkValidation="checkStatusEndReasonSelected"
              :parentValue="statusEndReasons"
              @updateCheckValidation="updatecheckStatusEndReasonSelected"
              @getSelected="getStatusEndReasonSelected"
            />
            <b-form-group>
              <requiredComponent
                slot="label"
                :label="$lang.profileLang.description"
                :rules="$v.description.$params"
                for="description"
              />
              <b-form-textarea
                class="input-style-offres"
                id="description"
                v-model="$v.description.$model"
                type="text"
                autocomplete="off"
                :rows="4"
                :placeholder="$lang.profileLang.description"
                :state="$v.description.$dirty ? !$v.description.$error : null"
              >
              </b-form-textarea>

              <b-form-invalid-feedback
                :style="{
                  display: $v.description.$error ? 'block' : 'none',
                }"
                id="description_feedback"
              >
                {{
                  $lang.error_required | replace($lang.profileLang.description)
                }}
              </b-form-invalid-feedback>
            </b-form-group>
            <TagComponent
              category_name="tag_parvandeh"
              :multiple="true"
              :requiredLabel="tagInputRequired"
              :parentPermissions="parentPermissions"
              :checkValidation="checkTagSelected"
              :parentValue="tags"
              @updateCheckValidation="updateCheckTagSelected"
              @getSelected="getSelected"
            />
            <UploadFile
              v-if="code"
              :crop="false"
              :file_types="file_types"
              :parentPermissions="parentPermissions"
              keyServies="parvandeh"
              :keyValue="code"
              :showForm="true"
              :allowCollapse="false"
              :isCollapseFiles="true"
              :parentUploadFile="false"
              :showCheckbox="false"
              :maxUploadFile="10485760"
              attachmentRoute="attachment_parvandeh"
              :multiple="false"
              :propAttachmentType="true"
              :parent_attachment_type_options="attachmentTypeParvandehOptions"
              classFile="col-12 col-sm-6 col-md-6 col-xl-6"
            />
            <div slot="footer" class="form-group form-btn mt-3">
              <b-button
                v-if="isAdmin(parentPermissions)"
                type="reset"
                class="mr-2"
                variant="outline-danger"
                @click="$emit('closeModal')"
              >
                <mdicon name="close" size="20" />
                {{ $lang.close }}
              </b-button>
              <b-button
                v-if="isAdmin(parentPermissions)"
                type="submit"
                variant="success"
              >
                <mdicon name="check" size="20" />

                {{ $lang.submitButton }}
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { renderEumOptions, isAdmin } from "@/shared/utils";
import TagComponent from "@/components/tag/tagComponent.vue";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import UploadFile from "@/components/base/uploadFile";

export default {
  validations: {
    status_selected: {
      required,
    },
    description: {},
  },
  components: { LoadingSpinner, TagComponent, UploadFile },
  props: {
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    parvandehCode: {
      type: [String, Number],
      default: null,
    },
    parvandehName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loadingItem: false,
      status_selected: null,
      status_selected_Loading: null,
      description: null,
      tags: null,
      checkTagSelected: false,
      code: null,
      item: null,
      loadingText: this.$lang.receiving_data,
      tagInputRequired: false,
      statusEndReasonRequired: true,
      statusEndReasons: null,
      checkStatusEndReasonSelected: false,
      file_types: ["image", "office", "media", "other"],
    };
  },
  computed: {
    headerTitle() {
      return this.$lang.profileLang.edit_new_parvandeh.replace(
        "{0}",
        this.parvandehName
      );
    },
    status_options() {
      return renderEumOptions("parvandeh_status");
    },
    status_end_reason_options() {
      return renderEumOptions("parvandeh_end_reason");
    },
    allowReasonId() {
      return pathOr(0, ["value"], this.status_selected) === 2;
    },
    attachmentTypeParvandehOptions() {
      return renderEumOptions("attachment_type_parvandeh");
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    getSelected(data) {
      this.tags = data;
    },
    updateCheckTagSelected(data) {
      this.checkTagSelected = data;
    },
    getStatusEndReasonSelected(data) {
      this.statusEndReasons = data;
    },
    updatecheckStatusEndReasonSelected(data) {
      this.checkStatusEndReasonSelected = data;
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      this.checkTagSelected = true;
      this.checkStatusEndReasonSelected = true;
      if (this.tagInputRequired && !this.tags.length) return;
      if (this.allowReasonId && !this.statusEndReasons) return;

      try {
        this.loadingItem = true;
        this.loadingText = this.$lang.receiving_data;
        let payload = {
          status: pathOr(null, ["value"], this.status_selected),
          comment: this.description,
          tag_id: this.tags.map((item) => item.value),
        };

        if (this.allowReasonId) {
          const status_end_reason_id = pathOr(
            null,
            ["value"],
            this.statusEndReasons
          );
          payload = { ...payload, status_end_reason_id };
        }
        const parvandehCode = pathOr(null, ["code"], this.item);
        const url = `${this.$config.api_url}${this.$config.profile.parvandeh}/${parvandehCode}`;
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.$emit("closeModal");
        this.$emit("getData");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loadingItem = false;
      }
    },
    async getParvandeh() {
      try {
        this.loadingItem = true;
        const url = `${this.$config.api_url}${this.$config.profile.parvandeh}/${this.parvandehCode}`;
        const response = await this.$httpService.get(url);
        this.item = pathOr(null, ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loadingItem = false;
      }
    },
    async fetchData() {
      await this.getParvandeh();
      this.code = pathOr(null, ["code"], this.item);
      this.status_selected = this.status_options.find(
        (x) => x.value === pathOr(null, ["parvandeh_status", "id"], this.item)
      );
      const statusEndReason = pathOr(null, ["status_end_reason"], this.item);
      this.statusEndReasons = statusEndReason
        ? {
            text: pathOr(null, ["status_end_reason", "caption"], this.item),
            value: pathOr(null, ["status_end_reason", "id"], this.item),
          }
        : null;
      this.description = pathOr(null, ["comment"], this.item);
      this.tags = pathOr(null, ["tags"], this.item).map((x) => {
        return {
          text: pathOr(null, ["caption"], x),
          value: pathOr(null, ["id"], x),
        };
      });
    },
  },
};
</script>
